const LEVELS = ["full", "balanced", "lite"];

export class WorldMapQuality {
	constructor(onChange) {
		const cores = navigator.hardwareConcurrency || 8;
		const memory = navigator.deviceMemory || 8;
		const constrained = navigator.connection?.saveData || window.matchMedia("(update: slow)").matches;
		this.mode = constrained || cores <= 2 || memory <= 2 ? "lite"
			: cores <= 4 || memory <= 4 ? "balanced" : "full";
		this.onChange = onChange;
		this.samples = [];
		this.previous = null;
	}

	begin() {
		this.previous = null;
	}

	record(time) {
		if (this.mode === "lite") return;
		if (this.previous !== null) {
			const interval = time - this.previous;
			if (interval > 0 && interval < 500) this.samples.push(interval);
		}
		this.previous = time;
		if (this.samples.length < 24) return;
		const samples = this.samples.splice(0).sort((a, b) => a - b);
		const slowFrame = samples[Math.floor(samples.length * 0.9)];
		const threshold = this.mode === "full" ? 34 : 55;
		if (slowFrame > threshold) {
			this.mode = LEVELS[LEVELS.indexOf(this.mode) + 1];
			this.onChange(this.mode);
		}
	}
}
